import { render, staticRenderFns } from "./PrivacyConditions.vue?vue&type=template&id=9f0c6744&scoped=true&"
import script from "./PrivacyConditions.vue?vue&type=script&lang=js&"
export * from "./PrivacyConditions.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyConditions.vue?vue&type=style&index=0&id=9f0c6744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0c6744",
  null
  
)

export default component.exports